import React from "react";
import ModelEntry from "./ModelEntry";
import ModalListEntry from "./ModalListEntry";
import { checkBool, hasProperty } from "../../../utils/helpers";
import { getUpdatedUniqueIds } from "../../rightSide/parameters/parameterLogic";

export function hasParentOrChildWithID(modelList, targetID, checkID) {
  for (let i = 0; i < modelList.length; i++) {
    const model = modelList[i];
    if (model.FE_ID === targetID) {
      if (hasIDInChildren(model.subModels, checkID)) {
        return true;
      }
    } else if (model.FE_ID === checkID) {
      if (hasIDInChildren(model.subModels, targetID)) {
        return true;
      }
    } else {
      if (hasIDInDescendants(model.subModels, targetID, checkID)) {
        return true;
      }
    }
  }
  return false;
}

function hasIDInChildren(subList, id) {
  for (let i = 0; i < subList.length; i++) {
    const subObj = subList[i];
    if (subObj.FE_ID === id) {
      return true;
    }
    if (hasIDInChildren(subObj.subModels, id)) {
      return true;
    }
  }
  return false;
}

function hasIDInDescendants(subModelList, targetID, checkID) {
  for (let i = 0; i < subModelList.length; i++) {
    const subModel = subModelList[i];
    if (subModel.FE_ID === targetID) {
      if (hasIDInChildren(subModel.subModels, checkID)) {
        return true;
      }
    } else if (subModel.FE_ID === checkID) {
      if (hasIDInChildren(subModel.subModels, targetID)) {
        return true;
      }
    } else {
      if (hasIDInDescendants(subModel.subModels, targetID, checkID)) {
        return true;
      }
    }
  }
  return false;
}

export function getModelById(ID, modelList) {
  for (let i = 0; i < modelList.length; i++) {
    const model = modelList[i];
    if (model.FE_ID === ID) {
      return model;
    }
    if (model.subModels && model.subModels.length > 0) {
      const subModel = getModelById(ID, model.subModels);
      if (subModel) {
        return subModel;
      }
    }
  }
  return null;
}

export function getModelsByIds(ids, modelList) {
  let idSet = new Set(ids);
  let models = [];

  function searchModelList(modelList) {
    for (let i = 0; i < modelList.length; i++) {
      const model = modelList[i];
      if (idSet.has(model.FE_ID)) {
        models.push(model);
        idSet.delete(model.FE_ID);
        if (idSet.size === 0) {
          break; // All IDs have been found, no need to continue
        }
      }
      if (model.subModels && model.subModels.length > 0) {
        searchModelList(model.subModels);
      }
    }
  }

  searchModelList(modelList);
  return models;
}

export function replaceModelById(modelList, modelToCopy, ID) {
  const newModelList = [];
  for (let i = 0; i < modelList.length; i++) {
    const model = modelList[i];
    if (model.FE_ID === ID) {
      newModelList.push({ ...modelToCopy });
    } else {
      const newModel = { ...model };
      if (newModel.subModels && newModel.subModels.length > 0) {
        newModel.subModels = replaceModelById(
          newModel.subModels,
          modelToCopy,
          ID
        );
      }
      newModelList.push(newModel);
    }
  }
  return newModelList;
}

export function setLinked(objectIsLinked) {
  // set linked to true for the current object
  objectIsLinked.linked = true;

  // recursively set linked to true for all sub-objects
  for (let subModel of objectIsLinked.subModels) {
    setLinked(subModel);
  }
}

export function deleteModelByID(modelList, idList, affectedParentIDs = []) {
  let modelListToReturn = deepCopy(modelList);

  modelListToReturn = modelListToReturn.filter((model) => {
    if (idList.some((id) => id === model.FE_ID)) {
      return false;
    } else if (model.subModels) {
      let deletedSubModels = deleteModelByID(
        model.subModels,
        idList,
        affectedParentIDs
      );
      model.subModels = deletedSubModels.updatedList;
      affectedParentIDs = deletedSubModels.affectedParentIDs;
    }
    return true;
  });

  // Return both the updated list and the affected parent IDs
  return {
    updatedList: modelListToReturn,
    affectedParentIDs: affectedParentIDs,
  };
}

export function linkedSubModelAdd(
  addSubModTitle,
  objectList_p,
  ID_p,
  getID_p,
  allModels_p,
  upID_p,
  getAbbrDic_p,
  setLocalAbbrDic_p,
  namingDic_p,
  setNamingDic_p,
  recordedErrorLog,
  indexToInsert,
  allLocalLineshapes,
  currentUser,
  sendJsonMessage
) {
  let linkedSubModels = null;
  const linked = true;
  const objectListCopy = deepCopy(objectList_p);
  const allModelsCopy = deepCopy(allModels_p);

  linkedSubModelFinder(
    addSubModTitle,
    objectListCopy,
    ID_p,
    getID_p,
    allModelsCopy,
    upID_p,
    getAbbrDic_p,
    setLocalAbbrDic_p,
    namingDic_p,
    setNamingDic_p,
    linked,
    recordedErrorLog,
    allLocalLineshapes,
    currentUser,
    sendJsonMessage
  );

  function linkedSubModelFinder(
    addSubModTitle,
    objectList,
    ID,
    getID,
    allModels,
    upID,
    getAbbrDic,
    setLocalAbbrDic,
    namingDic,
    setNamingDic,
    linked,
    recordedErrorLog,
    allLocalLineshapes,
    currentUser,
    sendJsonMessage
  ) {
    for (let i = 0; i < objectList.length; i++) {
      if (linkedSubModels != null) {
        break;
      }
      let obj = objectList[i];
      if (obj.FE_ID === ID) {
        linkedSubModels = obj.subModelTypes.map((modelID) =>
          generateModel(
            addSubModTitle,
            modelID,
            getID,
            upID,
            getAbbrDic,
            setLocalAbbrDic,
            allModels,
            namingDic,
            setNamingDic,
            linked,
            recordedErrorLog,
            allLocalLineshapes,
            currentUser,
            sendJsonMessage
          )
        );
        break;
      } else {
        obj.subModels = linkedSubModelFinder(
          addSubModTitle,
          obj.subModels,
          ID,
          getID,
          allModels,
          upID,
          getAbbrDic,
          setLocalAbbrDic,
          namingDic,
          setNamingDic,
          linked,
          recordedErrorLog,
          allLocalLineshapes,
          currentUser,
          sendJsonMessage
        );
      }
    }
  }

  return addSubModelToModels(
    addSubModTitle,
    objectList_p,
    ID_p,
    getID_p,
    allModels_p,
    upID_p,
    getAbbrDic_p,
    setLocalAbbrDic_p,
    namingDic_p,
    setNamingDic_p,
    linkedSubModels,
    recordedErrorLog,
    indexToInsert,
    allLocalLineshapes,
    currentUser,
    sendJsonMessage
  );
}

export function addSubModelToModels(
  addSubModTitle,
  modelList,
  ID,
  getID,
  allModels,
  upID,
  getAbbrDic,
  setLocalAbbrDic,
  namingDic,
  setNamingDic,
  linkedSubModels = null,
  recordedErrorLog,
  indexToInsert,
  allLocalLineshapes,
  currentUser,
  sendJsonMessage
) {
  return modelList.map((model) => {
    if (model.FE_ID === ID) {
      let updatedIndexForInsertion =
        indexToInsert !== null
          ? indexToInsert
          : model.subModels.length / model.subModelTypes.length;

      const modelInsertionIndex =
        updatedIndexForInsertion * model.subModelTypes.length;

      let addedModels = [];

      // const nameIdDict = {};

      if (linkedSubModels === null) {
        const subModels = model.subModelTypes.map((modelID) => {
          const generatedSubModel = generateModel(
            addSubModTitle,
            modelID,
            getID,
            upID,
            getAbbrDic,
            setLocalAbbrDic,
            allModels,
            namingDic,
            setNamingDic,
            false,
            recordedErrorLog,
            allLocalLineshapes,
            currentUser,
            sendJsonMessage,
            false
          );

          // nameIdDict[subModToGenerate.modelName] = generatedSubModel.FE_ID;

          return generatedSubModel;
        });

        model.subModels.splice(modelInsertionIndex, 0, ...subModels);
        addedModels = subModels;
      } else {
        model.subModels.splice(modelInsertionIndex, 0, ...linkedSubModels);
        addedModels = linkedSubModels;
      }

      let rowObject = { ...model.recTemplate.row };

      // Here we make sure that default per line increments are respected
      if (
        model.recTemplate.params.some((param) => param.defaultperline !== null)
      ) {
        for (let j = 0; j < model.recTemplate.params.length; j++) {
          const parameter = model.recTemplate.params[j];

          if (parameter.defaultperline !== null) {
            rowObject = {
              ...rowObject,
              [parameter.name]:
                parameter.default +
                parameter.defaultperline * (updatedIndexForInsertion + 1),
            };
          }
        }
      }

      let updatedParamRow = [...model.recTemplate.params];

      const listOfModelHeadersToUse = model.recTemplate.params
        .filter((param) => param.type === "Model")
        .map((param) => param.name);

      let newRecRows = [...model.recTableRows];
      let newRecParams = [...model.recParams];

      // This WILL cause issues if we suddenly need to create 2 or more sub models but contained in separate lines
      for (let i = 0; i < addedModels.length; i++) {
        const newSubModel = addedModels[i];
        const headerTitleToUse = listOfModelHeadersToUse[i];

        rowObject[headerTitleToUse] = newSubModel.displayName;

        // if (
        //   model.recTemplate.params.some((param) => param.defaultperline != null)
        // ) {
        //   for (let j = 0; j < model.recTemplate.params.length; j++) {
        //     const element = model.recTemplate.params[j];

        //     if (element.defaultperline != null) {
        //       rowObject = {
        //         ...rowObject,
        //         [element.name]:
        //           element.default +
        //           element.defaultperline * (updatedIndexForInsertion + 1),
        //       };
        //     } else {
        //       rowObject = { ...rowObject, [element.name]: element.default };
        //     }
        //   }
        //   rowObject = {
        //     ...rowObject,
        //     Model: newSubModel.displayName,
        //   };
        // } else {
        //   rowObject = {
        //     ...model.recTemplate.row,
        //     Model: newSubModel.displayName,
        //   };
        // }

        // const updatedParamRow = [];
        // THIS WILL NEED SOME UPDATING IF WE START HAVING 2 MODELS PER REC PARAMETER ROW.
        // P.S. param.name === speqqle_id when it comes to models as parameters
        // for (let j = 0; j < model.recTemplate.params.length; j++) {
        //   const param = model.recTemplate.params[j];
        //   if (param.type === "Model") {
        //     const paramToReturn = {
        //       ...param,
        //       FE_ID: newSubModel.FE_ID,
        //     };
        //     updatedParamRow.push(paramToReturn);
        //   } else {
        //     updatedParamRow.push(param);
        //   }
        // }

        updatedParamRow = updatedParamRow.map((param) => {
          if (hasProperty(param, "name") && param.name === headerTitleToUse) {
            return { ...param, FE_ID: newSubModel.FE_ID };
          }

          return param;
        });

        // updatedIndexForInsertion++;
      }

      newRecParams.splice(updatedIndexForInsertion, 0, updatedParamRow);
      newRecRows.splice(updatedIndexForInsertion, 0, rowObject);
      model.recTableRows = newRecRows;
      model.recParams = newRecParams;
    } else {
      model.subModels = addSubModelToModels(
        addSubModTitle,
        model.subModels,
        ID,
        getID,
        allModels,
        upID,
        getAbbrDic,
        setLocalAbbrDic,
        namingDic,
        setNamingDic,
        linkedSubModels,
        recordedErrorLog,
        indexToInsert,
        allLocalLineshapes,
        currentUser,
        sendJsonMessage
      );
    }
    return model;
  });
}

export function unlinkModelList(
  modelList,
  indexPath,
  firstIDToUse,
  setLastID,
  getAbbrDic,
  namingDic,
  setLocalAbbrDic,
  setNamingDic,
  indexChain
) {
  let localList = [...modelList];
  let localFEID = firstIDToUse;

  recursiveUpdate(localList);

  function recursiveUpdate(listOfModels) {
    let indexInPath = indexPath.shift();
    let currentModel = listOfModels[indexInPath];
    const oldOriginalModel = deepCopy(currentModel);

    if (currentModel.linked) {
      currentModel.displayName = generateName(
        currentModel.abbreviation,
        getAbbrDic,
        namingDic,
        setLocalAbbrDic,
        setNamingDic,
        localFEID
      );
      currentModel.linked = false;
      currentModel.FE_ID = localFEID;
      localFEID++;
    }
    listOfModels[indexInPath] = currentModel;

    if (indexPath[0] != undefined) {
      const updates = recursiveUpdate(listOfModels[indexInPath].subModels);

      if (currentModel.subModels.length > 0) {
        currentModel = updateParamsAndRowsOfModel(
          currentModel,
          updates.old.FE_ID,
          updates.new,
          indexChain
        );
      }

      listOfModels[indexInPath] = currentModel;
    }

    return {
      new: currentModel,
      old: oldOriginalModel,
    };
  }

  setLastID(localFEID);
  return localList;
}

function countIds(obj, lookup = {}) {
  if (Array.isArray(obj)) {
    obj.forEach((element) => countIds(element, lookup));
  } else if (typeof obj === "object" && obj !== null) {
    if ("FE_ID" in obj) {
      if (!(obj.FE_ID in lookup)) {
        lookup[obj.FE_ID] = 0;
      }
      lookup[obj.FE_ID]++;
    }

    if ("subModels" in obj) {
      countIds(obj.subModels, lookup);
    }
  }
}

function updateLinks(obj, lookup) {
  if (Array.isArray(obj)) {
    obj.forEach((element) => updateLinks(element, lookup));
  } else if (typeof obj === "object" && obj !== null) {
    if ("FE_ID" in obj && lookup[obj.FE_ID] === 1) {
      obj.linked = false;
    }

    if ("subModels" in obj) {
      updateLinks(obj.subModels, lookup);
    }
  }
}

export function refreshLinks(modelList) {
  const lookup = {};
  countIds(modelList, lookup);
  updateLinks(modelList, lookup);
  return lookup;
}

function displayModels(
  modelData,
  renameModel,
  startLinking,
  isLinkActive,
  deleteModel,
  addSubModel,
  parentIndex,
  unlinkModel,
  canLink,
  canBeDeleted,
  namingDic,
  linkingID,
  handleUnlinkingBeforeDelete,
  checkIfBatchContainsLinked,
  batchSizeFromParent,
  subModelLenghtFromParent = null
) {
  let subModel = <></>;
  if (modelData.subModels.length > 0) {
    subModel = [];
    for (let i = 0; i < modelData.subModels.length; i++) {
      const deeperIndex = parentIndex + ";" + i;

      // Determine if this submodel can be deleted:
      // Check if this is a non-recurring submodel by examining if the parent model
      // has a non-recurring Model parameter pointing to it
      const isNonRecurringSubmodel = modelData.modelParams.some(
        (param) =>
          param.type === "Model" &&
          param.recuring === 0 &&
          hasProperty(param, "FE_ID") &&
          param.FE_ID === modelData.subModels[i].FE_ID
      );

      // Only allow deletion if not a non-recurring submodel and if there are more submodels than minimum count
      let canBeDeletedNext = false;
      if (
        !isNonRecurringSubmodel &&
        modelData.subModels.length > modelData.minSubModelCount
      ) {
        canBeDeletedNext = true;
      }

      subModel.push(
        displayModels(
          modelData.subModels[i],
          renameModel,
          startLinking,
          isLinkActive,
          deleteModel,
          addSubModel,
          deeperIndex,
          unlinkModel,
          canLink,
          canBeDeletedNext,
          namingDic,
          linkingID,
          handleUnlinkingBeforeDelete,
          checkIfBatchContainsLinked,
          hasProperty(modelData, "subModelTypes") &&
            modelData.subModelTypes.length > 0
            ? modelData.subModelTypes.length
            : null,
          modelData.subModels.length
        )
      );
    }
  }

  const keyFromIndexes = parseInt("1" + parentIndex.replaceAll(";", ""));
  const nameForDisplay = hasProperty(namingDic, modelData.FE_ID)
    ? namingDic[modelData.FE_ID]
    : modelData.displayName;

  const isLinked = hasProperty(modelData, "linked") ? modelData.linked : false;

  const displayIndex = parseInt(parentIndex.split(";").pop());

  return (
    <div
      className={`nestedModels`}
      key={keyFromIndexes + "|" + modelData.FE_ID}
      data-key={parentIndex}
    >
      <ModelEntry
        modelName={nameForDisplay}
        canAdd={modelData.canAdd}
        linked={isLinked}
        ID={modelData.FE_ID}
        addSubModel={addSubModel}
        unlink={unlinkModel}
        handleUnlinkingBeforeDelete={handleUnlinkingBeforeDelete}
        checkIfBatchContainsLinked={checkIfBatchContainsLinked}
        startLink={startLinking}
        deleteEntry={deleteModel}
        setModelName={renameModel}
        isLinkActive={isLinkActive}
        // canLink={canLink}
        canBeDeleted={canBeDeleted}
        speqqleID={modelData.speqqleID}
        indexChain={parentIndex}
        linkingID={linkingID}
      />
      {subModel}
      {batchSizeFromParent !== null &&
      batchSizeFromParent > 1 &&
      (displayIndex + 1) % batchSizeFromParent === 0 &&
      displayIndex + 1 !== subModelLenghtFromParent ? (
        <div className="bottomDivider" />
      ) : (
        <></>
      )}
    </div>
  );
}

export function createModelsForDisplay(
  modelData,
  renameModel,
  startLinking,
  isLinkActive,
  deleteModel,
  addSubModel,
  unlinkModel,
  canLink,
  namingDic,
  linkingID,
  handleUnlinkingBeforeDelete,
  checkIfBatchContainsLinked,
  batchSizeFromParent = null
) {
  let modelsForDisplay = [];
  for (let i = 0; i < modelData.length; i++) {
    const parentIndex = "" + i;
    const canBeDeleted = true;
    modelsForDisplay.push(
      displayModels(
        modelData[i],
        renameModel,
        startLinking,
        isLinkActive,
        deleteModel,
        addSubModel,
        parentIndex,
        unlinkModel,
        canLink,
        canBeDeleted,
        namingDic,
        linkingID,
        handleUnlinkingBeforeDelete,
        checkIfBatchContainsLinked,
        batchSizeFromParent,
        null
      )
    );
  }

  return modelsForDisplay;
}

export function deepCopy(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(deepCopy);
  }

  const copiedObj = {};
  for (const key in obj) {
    copiedObj[key] = deepCopy(obj[key]);
  }

  return copiedObj;
}

export function updateDisplayName(modelData, ID, newName) {
  // Create a new copy of the model data array
  const newData = [...modelData];

  let renamedDict = {};

  // Loop through each object in the model data array
  newData.forEach((model) => {
    // If the current object's FE_ID matches the provided ID, update its displayName property
    if (model.FE_ID === ID) {
      model.displayName = newName;
      renamedDict[ID] = newName;
    }

    // If the current object has subModels, recursively call this function on each subModel
    if (model.subModels && model.subModels.length > 0) {
      const dataObj = updateDisplayName(model.subModels, ID, newName);
      model.subModels = dataObj.data;

      if (Object.keys(dataObj.renameDict).length > 0) {
        for (let i = 0; i < model.recParams.length; i++) {
          const paramRow = model.recParams[i];

          for (let j = 0; j < paramRow.length; j++) {
            const param = paramRow[j];

            if (
              hasProperty(param, "FE_ID") &&
              param.FE_ID === ID &&
              hasProperty(dataObj.renameDict, param.FE_ID)
            ) {
              model.recTableRows[i][param.name] =
                dataObj.renameDict[param.FE_ID];
            }
          }
        }
      }
    }
  });

  // Return the object containing new model data array and dictionary of renamed models
  return { data: newData, renameDict: renamedDict };
}

export function isDescendant(event) {
  if (
    event != undefined &&
    (event.className === "models" ||
      event.className === "modelList" ||
      event.className === "nestedModels" ||
      event.className === "modelEntry" ||
      event.className === "modelEntryName" ||
      event.className === "modelEntryIcon")
  ) {
    return true;
  } else {
    return false;
  }
}

export function constructModelList(modelList, handleModalEntryClick) {
  let localModels = [...modelList];
  localModels = localModels.map((model, index) => {
    return (
      <ModalListEntry
        key={index}
        modelName={model.name}
        modelDescription={model.description}
        speqqleID={model.speqqle_id}
        // id={model.id}
        // params={model.params}
        // abbreviation={model.abbreviation}
        handleClick={handleModalEntryClick}
      />
    );
  });

  return localModels;
}

function generateName(
  name,
  getAbbrDic,
  namingDic,
  setLocalAbbrDic,
  setNamingDic,
  idToPut
) {
  const abbrDic = getAbbrDic();
  if (hasProperty(namingDic, idToPut)) {
    return namingDic[idToPut];
  } else if (hasProperty(abbrDic, name)) {
    const nameWithNum = name + "_" + abbrDic[name];
    setLocalAbbrDic({ ...abbrDic, [name]: abbrDic[name] + 1 });
    setNamingDic((old) => {
      const updatedDict = deepCopy(old);
      return { ...updatedDict, [idToPut]: nameWithNum };
    });
    return nameWithNum;
  } else {
    setLocalAbbrDic({ ...abbrDic, [name]: 1 });
    setNamingDic((old) => {
      const updatedDict = deepCopy(old);
      return { ...updatedDict, [idToPut]: name };
    });
    return name;
  }
}

export function generateModel(
  addSubModTitle,
  modelSpeqqleID,
  getID,
  upID,
  getAbbrDic,
  setLocalAbbrDic,
  allModels,
  namingDic,
  setNamingDic,
  linked,
  recordedErrorLog,
  allLocalLineshapes,
  currentUser,
  sendJsonMessage,
  justForTemplate
) {
  const idToPut = getID();
  const currentModel = allModels.find(
    (model) => model.speqqle_id === modelSpeqqleID
  );
  const autoFit = currentModel.autofit == true;
  const vdf = currentModel.vdf == true;
  const sort = currentModel.sort ? true : false;
  const lineshape =
    currentModel.lineshape && currentModel.shapes.length > 0 ? true : false;
  //const tableTitles = currentModel.tableTitles || [];  // Default to empty array if not provided
  const tableTitles = currentModel.table_names
    ? currentModel.table_names
        .split(",") // Split on commas
        .map(
          (title) =>
            title
              .trim() // Remove whitespace
              .replace(/^"/, "") // Remove leading quote
              .replace(/"$/, "") // Remove trailing quote
        )
    : []; // Default to empty array if not provided
  const displayName = generateName(
    currentModel.abbreviation != null
      ? currentModel.abbreviation
      : currentModel.name,
    getAbbrDic,
    namingDic,
    setLocalAbbrDic,
    setNamingDic,
    idToPut
  );
  const canAdd = currentModel.params.some((param) => {
    return param.type == "Model" && param.recuring > 0;
  });

  // Call addSubModTitle for each parameter of type "Model"
  currentModel.params
    .filter((param) => param.type === "Model")
    .forEach((param) => {
      addSubModTitle(param.name);
    });

  const abbreviation =
    currentModel.abbreviation != null
      ? currentModel.abbreviation
      : currentModel.name;
  const subModelTypes = currentModel.params
    .filter((param) => param.type == "Model" && param.recuring > 0)
    .map((param) => parseInt(param.default));
  const modelOutputs = currentModel.outputs;
  const FE_ID = idToPut;
  upID();
  const BE_ID = currentModel.id;
  const modelDescription = currentModel.description;
  let subModelsToGenerate = [];
  let defaultNumRecRows = 1;
  if (
    currentModel.default_recuring !== undefined &&
    currentModel.default_recuring > 1
  ) {
    defaultNumRecRows = currentModel.default_recuring;
  }
  currentModel.params
    .filter((param) => param.type === "Model") // Filter all Model type params
    .forEach((param) => {
      if (param.recuring > 0) {
        // Add multiple instances for recurring models
        for (let i = 0; i < defaultNumRecRows; i++) {
          subModelsToGenerate.push({
            speqId: parseInt(param.default),
            modelName: param.name,
          });
        }
      } else {
        // Add single instance for non-recurring models
        subModelsToGenerate.push({
          speqId: parseInt(param.default),
          modelName: param.name,
        });
      }
    });

  const nameIdDict = {};

  const subModels = subModelsToGenerate.map((subModToGenerate) => {
    const generatedSubModel = generateModel(
      addSubModTitle,
      subModToGenerate.speqId,
      getID,
      upID,
      getAbbrDic,
      setLocalAbbrDic,
      allModels,
      namingDic,
      setNamingDic,
      false,
      recordedErrorLog,
      allLocalLineshapes,
      currentUser,
      sendJsonMessage,
      justForTemplate,
      false
    );

    nameIdDict[subModToGenerate.modelName] = generatedSubModel.FE_ID;

    return generatedSubModel;
  });

  const modelParams = currentModel.params.map((param) => {
    if (param.type === "Model" && param.recuring === 0) {
      const nonRecModelToUse = subModels.find(
        (model) => model.speqqleID === parseInt(param.default)
      );
      return {
        ...param,
        value: nonRecModelToUse.FE_ID,
        customFixed: param.fixed,
        FE_ID: nonRecModelToUse.FE_ID,
        name: param.name,
        // .replace(/\s+/g, "")
        // .replace(/\[/g, "(")
        // .replace(/\]/g, ")"),
      };
    } else if (param.type === "Checkbox" && param.recuring === 0) {
      return {
        ...param,
        value: param.default === 1,
        customFixed: param.fixed,
        name: param.name,
        // .replace(/\s+/g, "")
        // .replace(/\[/g, "(")
        // .replace(/\]/g, ")"),
      };
    }
    return {
      ...param,
      value: param.default,
      customFixed: param.fixed,
      name: param.name,
      // .replace(/\s+/g, "")
      // .replace(/\[/g, "(")
      // .replace(/\]/g, ")"),
    };
  });
  const recParams = [
    currentModel.params
      .filter(
        (param) =>
          param.recuring != 0 &&
          (param.type === "int" ||
            param.type === "float" ||
            param.type === "Checkbox" ||
            param.type === "Model")
      )
      .map((param) => {
        if (param.type === "int" || param.type === "float") {
          return {
            ...param,
            value: param.default,
            customFixed: param.fixed,
            name: param.name,
            // .replace(/\s+/g, "")
            // .replace(/\[/g, "(")
            // .replace(/\]/g, ")"),
          };
        } else if (param.type === "Checkbox") {
          return {
            ...param,
            value: param.default === 1,
            name: param.name,
            // .replace(/\s+/g, "")
            // .replace(/\[/g, "(")
            // .replace(/\]/g, ")"),
          };
        } else if (param.type === "Model") {
          // THIS WILL NEED SOME UPDATING IF WE START HAVING 2 MODELS PER REC PARAMETER ROW.
          // P.S. param.name === speqqle_id when it comes to models as parameters
          const idOfGeneratedModel = nameIdDict[param.name];
          const paramToReturn = {
            ...param,
            FE_ID: idOfGeneratedModel,
          };
          return paramToReturn;
        } else {
          return param;
        }
      }),
  ].filter((paramArray) => paramArray.length > 0);
  let recTableRow = null;
  let recTableRows = [];
  let recTemplate = null;
  let lineshapeData = [];
  if (recParams.length > 0) {
    //  if (
    //  subModels.length > 0 &&
    //  recParams[0].some((param) => param.type === "Model")
    //  ) {
    let templateRow = {};
    for (let i = 0; i < recParams[0].length; i++) {
      const param = recParams[0][i];
      if (param.type === "Model") {
        const idOfGeneratedModel = nameIdDict[param.name];
        const modelToUse = subModels.find(
          (model) => model.FE_ID === idOfGeneratedModel
        );
        if (!modelToUse) {
          throw new Error(
            "Submodel expected but not found. Please contact support."
          );
        }
        addSubModTitle(param.name);
        templateRow = {
          ...templateRow,
          [param.name]: modelToUse.displayName,
        };
      } else {
        templateRow = { ...templateRow, [param.name]: param.value };
      }
    }

    for (let i = 0; i < defaultNumRecRows; i++) {
      if (i > 0) {
        // If we are here, it means we will have multiple rows of rec params with sub models, therefore on index = 1
        const updatedParamRow = [];
        // THIS WILL NEED SOME UPDATING IF WE START HAVING 2 MODELS PER REC PARAMETER ROW.
        // P.S. param.name === speqqle_id when it comes to models as parameters
        for (let j = 0; j < recParams[0].length; j++) {
          const param = recParams[0][j];
          if (param.type === "Model") {
            // HERE STILL NEEDS UPDATE!!!
            // const subModel = subModels[i];
            // if (!subModel) {
            //   throw new Error(
            //     "Submodel expected but not found. Please contact support."
            //   );
            // }
            // const paramToReturn = {
            //   ...param,
            //   FE_ID: subModel.FE_ID,
            // };
            // updatedParamRow.push(paramToReturn);
          } else {
            if (param.defaultperline !== undefined) {
              const newValue = param.default + param.defaultperline * i;
              const paramToReturn = {
                ...param,
                value: newValue,
              };
              updatedParamRow.push(paramToReturn);
              templateRow = {
                ...templateRow,
                [param.name]: newValue,
              };
            } else {
              updatedParamRow.push(param);
            }
          }
        }
        recParams.push(updatedParamRow);
      }

      // if (recParams[0].some((param) => param.type === "Model")) {
      //   const subModel = subModels[i];
      //   if (!subModel) {
      //     throw new Error(
      //       "Submodel expected but not found. Please contact support."
      //     );
      //   }
      //   recTableRows.push({ ...templateRow, Model: subModel.displayName });
      // } else {
      // }

      recTableRows.push(templateRow);
    }

    recTableRow = recTableRows[0];
    recTemplate = {
      row: deepCopy(recTableRow),
      params: deepCopy(recParams[0]),
    };
  } else if (!justForTemplate && lineshape && defaultNumRecRows > 0) {
    let lineshapeTemplate = allLocalLineshapes.find(
      (ls) => ls.lineshape_id === 0
    );
    if (!lineshapeTemplate) {
      sendJsonMessage(
        {
          User: currentUser.id,
          Model: { GetShapeSpecs: [0] },
        },
        {
          type: "get-shape-specs",
          requestedModelID: [FE_ID],
          numberOfRows: defaultNumRecRows,
        }
      );
    } else {
      let newLineshapeData = {
        lineshape_id: 0,
        lineTemplate: deepCopy(lineshapeTemplate.lineTemplate),
        lineParams: [],
        lineTableRows: [],
      };
      for (let i = 0; i < defaultNumRecRows; i++) {
        let newLineParams = [];
        let newLineTableRow = {};
        for (let j = 0; j < newLineshapeData.lineTemplate.params.length; j++) {
          let paramValue =
            newLineshapeData.lineTemplate.params[j].default !== undefined
              ? newLineshapeData.lineTemplate.params[j].default
              : 0;
          paramValue +=
            newLineshapeData.lineTemplate.params[j].defaultperline !== undefined
              ? newLineshapeData.lineTemplate.params[j].defaultperline * i
              : 0;
          let paramCustomFixed =
            newLineshapeData.lineTemplate.params[j].fixed !== undefined
              ? newLineshapeData.lineTemplate.params[j].fixed
              : false;
          let newLineParam = {
            ...newLineshapeData.lineTemplate.params[j],
            value: paramValue,
            customFixed: paramCustomFixed,
          };
          newLineParams.push(newLineParam);
          newLineTableRow[newLineParam.name] = paramValue;
        }
        newLineshapeData.lineParams.push(newLineParams);
        newLineshapeData.lineTableRows.push(newLineTableRow);
      }
      lineshapeData.push(newLineshapeData);
    }
  }

  const minSubModelCount = canAdd ? 1 : 0;

  if (recParams.length > 0 && recTableRow != null) {
    return {
      displayName,
      canAdd,
      autoFit,
      vdf,
      lineshape,
      abbreviation,
      minSubModelCount,
      modelParams,
      FE_ID,
      BE_ID,
      linked,
      subModelTypes,
      speqqleID: modelSpeqqleID,
      modelDescription,
      subModels: subModels,
      sort,
      recParams,
      recTableRows,
      recTemplate,
      outputs: modelOutputs,
      tableTitles,
    };
  } else if (lineshapeData && lineshapeData.length > 0) {
    return {
      displayName,
      canAdd,
      autoFit,
      vdf,
      lineshape,
      abbreviation,
      minSubModelCount,
      modelParams,
      FE_ID,
      BE_ID,
      linked,
      subModelTypes,
      speqqleID: modelSpeqqleID,
      modelDescription,
      subModels: subModels,
      sort,
      outputs: modelOutputs,
      tableTitles,
      lineshapeData: lineshapeData,
    };
  } else {
    return {
      displayName,
      canAdd,
      autoFit,
      vdf,
      lineshape,
      abbreviation,
      minSubModelCount,
      modelParams,
      FE_ID,
      BE_ID,
      linked,
      subModelTypes,
      speqqleID: modelSpeqqleID,
      modelDescription,
      subModels: subModels,
      sort,
      outputs: modelOutputs,
      tableTitles,
    };
  }
}

// export function generateModelFromFile(
//   modelFromFile,
//   getID,
//   upID,
//   getAbbrDic,
//   setLocalAbbrDic,
//   namingDic,
//   setNamingDic,
//   linked = false
// ) {
//   const idToPut = getID();
//   const FE_ID = idToPut;
//   upID();

//   const displayName = generateName(
//     modelFromFile.displayName,
//     getAbbrDic,
//     namingDic,
//     setLocalAbbrDic,
//     setNamingDic,
//     idToPut
//   );

//   const subModels = modelFromFile.subModels.map((model) =>
//     generateModelFromFile(
//       model,
//       getID,
//       upID,
//       getAbbrDic,
//       setLocalAbbrDic,
//       namingDic,
//       setNamingDic
//     )
//   );

//   let modelToReturn = {
//     displayName,
//     canAdd: modelFromFile.canAdd,
//     autoFit: modelFromFile.autoFit,
//     vdf: modelFromFile.vdf,
//     lineshape: modelFromFile.lineshape,
//     abbreviation: modelFromFile.abbreviation,
//     minSubModelCount: modelFromFile.minSubModelCount,
//     modelParams: modelFromFile.modelParams,
//     FE_ID,
//     BE_ID: "!THIS ID IS NEVER USED AND THEREFORE NOT BEING SET HERE!",
//     linked,
//     subModelTypes: modelFromFile.subModelTypes,
//     speqqleID: modelFromFile.speqqleID,
//     outputs: modelFromFile.outputs,
//     modelDescription: modelFromFile.modelDescription,
//     subModels: subModels,
//   };

//   if (hasProperty(modelFromFile, "recParams")) {
//     modelToReturn = {
//       ...modelToReturn,
//       recParams: modelFromFile.recParams,
//       recTableRows: modelFromFile.recTableRows,
//       recTemplate: modelFromFile.recTemplate,
//     };
//   }
//   if (hasProperty(modelFromFile, "curve")) {
//     modelToReturn = {
//       ...modelToReturn,
//       curves: modelFromFile.curves,
//     };
//   }
//   if (hasProperty(modelFromFile, "lineshapeData")) {
//     modelToReturn = {
//       ...modelToReturn,
//       lineshapeData: modelFromFile.lineshapeData,
//     };
//   }
//   if (hasProperty(modelFromFile, "vdfData")) {
//     modelToReturn = {
//       ...modelToReturn,
//       vdfData: modelFromFile.vdfData,
//     };
//   }
//   return modelToReturn;
// }

export function createModelFromParamList(
  modelLoaded,
  modelTemplate,
  generateModel,
  sendJsonMessage,
  currentUser,
  allLocalLineshapes
) {
  let modelTemplateCopy = deepCopy(modelTemplate);
  // Adding outputs to the model template
  // modelTemplateCopy.outputs = modelLoaded.outputs;
  // let strangeResults = false;
  // Find non recuring params from model
  const nonRecParams = modelTemplateCopy.modelParams.filter(
    (param) => param.recuring == 0
  );

  // Get new parameters for the model, remove first entry, since it's not needed
  modelLoaded = convertModelFormat(modelLoaded);
  const modelParamsToUse = deepCopy(modelLoaded.parameters.global);
  if (modelTemplate.speqqleID !== 0) {
    modelParamsToUse.shift(); // IF NOT A MATERIAL(DL) MODEL ONLY!
  }

  let recParamsForUpdate = [];
  const hasRec =
    hasProperty(modelTemplateCopy, "recTemplate") &&
    modelTemplateCopy.recTemplate.params.length > 0;
  // From a model recuring parameter template, get a parameter with a smallest speqqle id
  const smallestIDTemplateParam = hasRec
    ? modelTemplateCopy.recTemplate.params.reduce(
        (min, param) => (min.speqqle_id < param.speqqle_id ? min : param),
        modelTemplateCopy.recTemplate.params[0]
      )
    : null;

  // In this array we will keep all the found parameters and we will use it to check which parameters
  // have not been used
  let allFoundParams = [];

  // Loop through all the new parameters to sort them
  for (let i = 0; i < modelParamsToUse.length; i++) {
    const modelParam = modelParamsToUse[i];
    // If new parameter matches non recuring parameter speqqle id, update the non recuring parameter
    if (
      nonRecParams.some((param) => param.speqqle_id == modelParam.speqqle_id)
    ) {
      modelTemplateCopy.modelParams = modelTemplateCopy.modelParams.map(
        (param) => {
          if (param.speqqle_id !== modelParam.speqqle_id) {
            return param;
          }

          // Check if this is a Model type parameter (non-recurring submodel)
          if (
            param.type === "Model" &&
            param.recuring === 0 &&
            modelParam.value
          ) {
            // Find the submodel that needs to be updated
            const idOfModelToChange = param.FE_ID;

            // Generate or retrieve the new submodel using the callback
            const newlyGeneratedModel = generateModel(
              parseInt(param.default), // speqqleId - using the default value which contains the model type
              modelParam.value, // FE_ID - this is the model ID from the loaded file
              idOfModelToChange
            );

            // Update the submodel in the subModels array
            modelTemplateCopy.subModels = modelTemplateCopy.subModels.map(
              (subMod) => {
                if (subMod.FE_ID === idOfModelToChange) {
                  if (hasProperty(newlyGeneratedModel, "recParams")) {
                    subMod.recParams = newlyGeneratedModel.recParams;
                  }
                  subMod.modelParams = newlyGeneratedModel.modelParams;
                  if (hasProperty(newlyGeneratedModel, "recTableRows")) {
                    subMod.recTableRows = newlyGeneratedModel.recTableRows;
                  }
                  if (hasProperty(newlyGeneratedModel, "recTemplate")) {
                    subMod.recTemplate = newlyGeneratedModel.recTemplate;
                  }
                  if (hasProperty(newlyGeneratedModel, "subModels")) {
                    subMod.subModels = newlyGeneratedModel.subModels;
                  }
                  // Also copy lineshapeData if it exists
                  if (hasProperty(newlyGeneratedModel, "lineshapeData")) {
                    subMod.lineshapeData = newlyGeneratedModel.lineshapeData;
                  }
                  return subMod;
                } else {
                  return subMod;
                }
              }
            );

            // Update both the value AND the FE_ID of the parameter to maintain proper reference
            return {
              ...param,
              value: modelParam.value,
              FE_ID: newlyGeneratedModel.FE_ID, // Update FE_ID to match the new submodel
            };
          }

          // For regular parameters (not submodels)
          const newParam = {
            ...param,
            value:
              param.type !== "Checkbox"
                ? modelParam.value
                : checkBool(modelParam.value),
          };
          if (hasProperty(modelParam, "matched")) {
            newParam.group = modelParam.matched;
          } else if (Object.prototype.hasOwnProperty.call(newParam, "group")) {
            delete newParam.group;
          }
          if (hasProperty(modelParam, "hardmax")) {
            newParam.hardMax = modelParam.hardmax;
          } else if (
            Object.prototype.hasOwnProperty.call(newParam, "hardMax")
          ) {
            delete newParam.hardMax;
          }
          if (hasProperty(modelParam, "hardmin")) {
            newParam.hardMin = modelParam.hardmin;
          } else if (
            Object.prototype.hasOwnProperty.call(newParam, "hardMin")
          ) {
            delete newParam.hardMin;
          }
          if (modelParam.fixed && !newParam.fixed) {
            newParam.customFixed = true;
          } else {
            newParam.customFixed = newParam.fixed;
          }
          return newParam;
        }
      );

      // Add Non Recuring parameters to the list of found values
      allFoundParams.push(modelParam);
    } else {
      // If it doesn't match, that means the new parameter is potentially a recuring one, add it to
      // possibly recuring parameter array if its speqqle id is equal or higher than the smallest template speqqle id
      // this prevents of adding values which are guaranteed unfit for the recuring parameters
      if (
        hasRec &&
        modelParam.speqqle_id >= smallestIDTemplateParam.speqqle_id
      ) {
        recParamsForUpdate.push(modelParam);
      }
      // else {
      //   if (modelParam.value !== 10 && modelParam.value !== 100) {
      //     // strangeResults = true;
      //   }
      // }
    }
  }

  if (hasRec) {
    // Find the new parameter with the largest speqqle id
    const paramForUpdateWithLargestID = recParamsForUpdate.reduce(
      (max, param) => (max.speqqle_id > param.speqqle_id ? max : param),
      recParamsForUpdate[0]
    );

    // Find the recuring parameter from a template with the largest speqqle id and recuring value combination for
    // given largest speqqle id of parameter for updating
    const largestIDModelTemplateParam =
      modelTemplateCopy.recTemplate.params.reduce(
        (max, param) =>
          (paramForUpdateWithLargestID.speqqle_id - max.speqqle_id) /
            max.recuring >
          (paramForUpdateWithLargestID.speqqle_id - param.speqqle_id) /
            param.recuring
            ? max
            : param,
        modelTemplateCopy.recTemplate.params[0]
      );

    // Calculate maximum possible recuring table rows
    const maxPossibleRows = Math.floor(
      (paramForUpdateWithLargestID.speqqle_id -
        largestIDModelTemplateParam.speqqle_id) /
        largestIDModelTemplateParam.recuring
    );

    let rowsOfValues = [];

    // Loop until max possible rows are reached, <= is used because we calculate rows from 0
    for (let row = 0; row <= maxPossibleRows; row++) {
      let values = [];
      // loop through template parameters to match each parameter with
      for (
        let paramIndex = 0;
        paramIndex < modelTemplateCopy.recTemplate.params.length;
        paramIndex++
      ) {
        // Find the value according to a parameter from the template
        const param = modelTemplateCopy.recTemplate.params[paramIndex];
        let foundValue;
        if (param.type === "Model") {
          const modelDataFromLoaded = recParamsForUpdate.find(
            (paramToUpdate) =>
              paramToUpdate.speqqle_id ==
              param.speqqle_id + row * param.recuring
          );
          foundValue = {
            modelSpeqqleId: parseInt(param.default),
            type: param.type,
            speqqle_id: param.speqqle_id,
            FE_ID: modelDataFromLoaded.value,
            columnName: param.name,
          };
        } else {
          foundValue = recParamsForUpdate.find(
            (paramToUpdate) =>
              paramToUpdate.speqqle_id ==
              param.speqqle_id + row * param.recuring
          );
        }
        // Add recuring parameters to the list of found values
        allFoundParams.push(foundValue);
        // If the value is found, push it to the value row
        if (foundValue !== undefined) {
          let valueToUse;

          if (foundValue.type === "Model") {
            valueToUse = { ...foundValue };
          } else {
            valueToUse = {
              value:
                param.type !== "Checkbox"
                  ? foundValue.value
                  : checkBool(foundValue.value),
              speqqle_id: param.speqqle_id,
            };
            if (foundValue.fixed !== undefined) {
              valueToUse.fixed = foundValue.fixed;
            }
            if (hasProperty(foundValue, "matched")) {
              valueToUse.group = foundValue.matched;
            }
            if (hasProperty(foundValue, "hardmax")) {
              valueToUse.hardMax = foundValue.hardmax;
            }
            if (hasProperty(foundValue, "hardmin")) {
              valueToUse.hardMin = foundValue.hardmin;
            }
          }
          values.push(valueToUse);
        }
      }
      // Push the row of values to the array of rows
      rowsOfValues.push(values);
    }

    // Check if the last row is completely filled, if not, discard it
    if (
      rowsOfValues[rowsOfValues.length - 1].length !==
      modelTemplateCopy.recTemplate.params.length
    ) {
      rowsOfValues.pop();
    }
    // Loop through the array of new row values
    for (let rowIndex = 0; rowIndex < rowsOfValues.length; rowIndex++) {
      const rowValues = rowsOfValues[rowIndex];

      // Check if the row is in the recuring parameters table
      if (modelTemplateCopy.recParams.length > rowIndex) {
        // If the recuring parameters table contains this row, do the updates
        for (let i = 0; i < modelTemplateCopy.recParams[rowIndex].length; i++) {
          // Find the value from row values that matches rec table parameter speqqle id
          const foundVal = rowValues.find(
            (rowVal) =>
              rowVal.speqqle_id ===
              modelTemplateCopy.recParams[rowIndex][i].speqqle_id
          );

          // If the value is found, update rec table parameter and row values
          // We skip this if foundVal is for model, since the model name used here should not change based on loaded params
          if (foundVal !== undefined) {
            if (foundVal.type !== "Model") {
              const recParamsUpdate = {
                ...modelTemplateCopy.recParams[rowIndex][i],
                value: foundVal.value,
              };
              if (hasProperty(foundVal, "group")) {
                recParamsUpdate.group = foundVal.group;
              } else if (
                Object.prototype.hasOwnProperty.call(recParamsUpdate, "group")
              ) {
                delete recParamsUpdate.group;
              }
              if (hasProperty(foundVal, "hardMax")) {
                recParamsUpdate.hardMax = foundVal.hardMax;
              } else if (
                Object.prototype.hasOwnProperty.call(recParamsUpdate, "hardMax")
              ) {
                delete recParamsUpdate.hardMax;
              }
              if (hasProperty(foundVal, "hardMin")) {
                recParamsUpdate.hardMin = foundVal.hardMin;
              } else if (
                Object.prototype.hasOwnProperty.call(recParamsUpdate, "hardMin")
              ) {
                delete recParamsUpdate.hardMin;
              }
              if (foundVal.fixed !== undefined && foundVal.fixed) {
                recParamsUpdate.customFixed = true;
              } else {
                recParamsUpdate.customFixed = recParamsUpdate.fixed;
              }
              modelTemplateCopy.recParams[rowIndex][i] = recParamsUpdate;

              modelTemplateCopy.recTableRows[rowIndex] = {
                ...modelTemplateCopy.recTableRows[rowIndex],
                [modelTemplateCopy.recParams[rowIndex][i].name]: foundVal.value,
              };
            } else {
              const idOfModelToChange = deepCopy(
                modelTemplateCopy.recParams[rowIndex][i].FE_ID
              );
              const newlyGeneratedModel = generateModel(
                foundVal.modelSpeqqleId,
                foundVal.FE_ID,
                idOfModelToChange
              );
              modelTemplateCopy.subModels = modelTemplateCopy.subModels.map(
                (subMod) => {
                  if (subMod.FE_ID === idOfModelToChange) {
                    if (hasProperty(newlyGeneratedModel, "recParams")) {
                      subMod.recParams = newlyGeneratedModel.recParams;
                    }
                    subMod.modelParams = newlyGeneratedModel.modelParams;
                    if (hasProperty(newlyGeneratedModel, "recTableRows")) {
                      subMod.recTableRows = newlyGeneratedModel.recTableRows;
                    }
                    if (hasProperty(newlyGeneratedModel, "recTemplate")) {
                      subMod.recTemplate = newlyGeneratedModel.recTemplate;
                    }
                    if (hasProperty(newlyGeneratedModel, "subModels")) {
                      subMod.subModels = newlyGeneratedModel.subModels;
                    }
                    // Also copy lineshapeData if it exists
                    if (hasProperty(newlyGeneratedModel, "lineshapeData")) {
                      subMod.lineshapeData = newlyGeneratedModel.lineshapeData;
                    }
                    return subMod;
                  } else {
                    return subMod;
                  }
                }
              );
            }
          }
        }
      } else {
        // If row index of new values is greater than current recuring parameter table lenght, that means we
        // need to add additional parameter row from template
        let paramRow = [];
        let tableRow = {};

        // Loop through recuring parameters template
        for (let i = 0; i < modelTemplateCopy.recTemplate.params.length; i++) {
          // Find the value from values row that matches template parameter speqqle id
          const foundVal = rowValues.find(
            (rowVal) =>
              rowVal.speqqle_id ==
              modelTemplateCopy.recTemplate.params[i].speqqle_id
          );
          // If the value is found, add the paramter with value from row of values to temporary parameters
          // If the value is not found, we still add entry to the table, but with value from the template - this
          // prevents the creation of tables with undefined table cells
          if (foundVal != undefined) {
            if (foundVal.type !== "Model") {
              const updatedParamRow = {
                ...modelTemplateCopy.recTemplate.params[i],
                value: foundVal.value,
              };
              if (hasProperty(foundVal, "group")) {
                updatedParamRow.group = foundVal.group;
              }
              if (hasProperty(foundVal, "hardMax")) {
                updatedParamRow.hardMax = foundVal.hardMax;
              }
              if (hasProperty(foundVal, "hardMin")) {
                updatedParamRow.hardMin = foundVal.hardMin;
              }
              if (foundVal.fixed && !recParamsForUpdate.fixed) {
                updatedParamRow.customFixed = true;
              }
              paramRow.push(updatedParamRow);
              tableRow = {
                ...tableRow,
                [modelTemplateCopy.recTemplate.params[i].name]: foundVal.value,
              };
            } else {
              const newlyGeneratedModel = generateModel(
                foundVal.modelSpeqqleId,
                foundVal.FE_ID
              );
              tableRow = {
                ...tableRow,
                [foundVal.columnName]: newlyGeneratedModel.displayName,
              };
              const updatedParamRow = {
                ...modelTemplateCopy.recTemplate.params[i],
                FE_ID: newlyGeneratedModel.FE_ID,
              };
              paramRow.push(updatedParamRow);
              modelTemplateCopy.subModels.push(newlyGeneratedModel);
            }
          } else {
            paramRow.push({
              ...modelTemplateCopy.recTemplate.params[i],
            });
            tableRow = {
              ...tableRow,
              [modelTemplateCopy.recTemplate.params[i].name]:
                modelTemplateCopy.recTemplate.params[i].value,
            };
          }
        }

        // When temporary recuring parameter and table row values are filled, update model with them
        modelTemplateCopy.recParams.push(paramRow);
        modelTemplateCopy.recTableRows.push(tableRow);
      }

      // Here we will check if there are any other rows remaining in the parameter table after we finished adding ones from BE. We will remove them if found
      if (rowIndex === rowsOfValues.length - 1) {
        modelTemplateCopy.recTableRows.splice(rowIndex + 1);
        modelTemplateCopy.recParams.splice(rowIndex + 1);
      }
    }
  }
  if (
    hasProperty(modelLoaded, "vdf") &&
    hasProperty(modelTemplateCopy, "vdf") &&
    modelTemplateCopy.vdf
  ) {
    modelTemplateCopy.vdfData = modelLoaded.vdf;
  } else if (
    Object.prototype.hasOwnProperty.call(modelTemplateCopy, "vdfData")
  ) {
    delete modelTemplateCopy.vdfData;
  }
  if (
    hasProperty(modelLoaded.parameters, "lineshapes") &&
    hasProperty(modelTemplateCopy, "lineshape") &&
    modelTemplateCopy.lineshape
  ) {
    if (!hasProperty(modelTemplateCopy, "lineshapeData")) {
      modelTemplateCopy.lineshapeData = [];
    }
    let lineshapesToQuery = [];
    //remove lineshapes that are not in the loaded model
    for (let i = modelTemplateCopy.lineshapeData.length - 1; i >= 0; i--) {
      if (
        !modelLoaded.parameters.lineshapes.some(
          (lineshape) =>
            lineshape.lineshape_id ===
            modelTemplateCopy.lineshapeData[i].lineshape_id
        )
      ) {
        modelTemplateCopy.lineshapeData.splice(i, 1);
      }
    }

    for (let i = 0; i < modelLoaded.parameters.lineshapes.length; i++) {
      let newLineshapeData = {
        lineshape_id: modelLoaded.parameters.lineshapes[i].lineshape_id,
        lineParams: deepCopy(modelLoaded.parameters.lineshapes[i].shapes),
      };
      // Check if the lineshape is already in the model
      let lineshapeIndex = modelTemplateCopy.lineshapeData.findIndex(
        (lineshape) => lineshape.lineshape_id === newLineshapeData.lineshape_id
      );
      // get the template of the lineshape
      let lineshapeinuse = undefined;
      if (allLocalLineshapes) {
        lineshapeinuse = allLocalLineshapes.find(
          (lineshape) =>
            lineshape.lineshape_id === newLineshapeData.lineshape_id
        );
      }
      let lineshapeTemplate = undefined;
      if (lineshapeinuse !== undefined) {
        lineshapeTemplate = lineshapeinuse.lineTemplate;
      }
      if (lineshapeTemplate === undefined) {
        if (
          lineshapeIndex !== -1 &&
          hasProperty(
            modelTemplateCopy.lineshapeData[lineshapeIndex],
            "lineTemplate"
          )
        ) {
          lineshapeTemplate = deepCopy(
            modelTemplateCopy.lineshapeData[lineshapeIndex].lineTemplate
          );
        } else {
          lineshapesToQuery.push(
            modelLoaded.parameters.lineshapes[i].lineshape_id
          );
          for (let j = 0; j < newLineshapeData.lineParams.length; j++) {
            for (let k = 0; k < newLineshapeData.lineParams[j].length; k++) {
              if (hasProperty(newLineshapeData.lineParams[j][k], "matched")) {
                newLineshapeData.lineParams[j][k].group =
                  newLineshapeData.lineParams[j][k].matched;
                delete newLineshapeData.lineParams[j][k].matched;
              }
              if (hasProperty(newLineshapeData.lineParams[j][k], "hardmin")) {
                newLineshapeData.lineParams[j][k].hardMin =
                  newLineshapeData.lineParams[j][k].hardmin;
                delete newLineshapeData.lineParams[j][k].hardmin;
              }
              if (hasProperty(newLineshapeData.lineParams[j][k], "hardmax")) {
                newLineshapeData.lineParams[j][k].hardMax =
                  newLineshapeData.lineParams[j][k].hardmax;
                delete newLineshapeData.lineParams[j][k].hardmax;
              }
              if (
                !hasProperty(newLineshapeData.lineParams[j][k], "customFixed")
              ) {
                if (hasProperty(newLineshapeData.lineParams[j][k], "fixed")) {
                  newLineshapeData.lineParams[j][k].customFixed =
                    newLineshapeData.lineParams[j][k].fixed;
                }
              }
            }
          }
        }
      }
      if (lineshapeTemplate !== undefined) {
        newLineshapeData.lineTemplate = deepCopy(lineshapeTemplate);
        newLineshapeData.lineTableRows = [];
        for (let i = 0; i < newLineshapeData.lineParams.length; i++) {
          let row = {};
          let params = [];
          for (let j = 0; j < newLineshapeData.lineParams[i].length; j++) {
            let tempParam = deepCopy(
              newLineshapeData.lineTemplate.params.find(
                (param) =>
                  param.speqqle_id ===
                  newLineshapeData.lineParams[i][j].speqqle_id
              )
            );
            if (tempParam) {
              tempParam.value = newLineshapeData.lineParams[i][j].value;
              tempParam.customFixed = tempParam.fixed;
              if (hasProperty(newLineshapeData.lineParams[i][j], "group")) {
                tempParam.group = newLineshapeData.lineParams[i][j].group;
              } else if (
                hasProperty(newLineshapeData.lineParams[i][j], "matched")
              ) {
                tempParam.group = newLineshapeData.lineParams[i][j].matched;
              } else if (
                Object.prototype.hasOwnProperty.call(tempParam, "group")
              ) {
                delete tempParam.group;
              }
              if (hasProperty(newLineshapeData.lineParams[i][j], "hardmax")) {
                tempParam.hardMax = newLineshapeData.lineParams[i][j].hardmax;
              } else if (
                Object.prototype.hasOwnProperty.call(tempParam, "hardMax")
              ) {
                delete tempParam.hardMax;
              }
              if (hasProperty(newLineshapeData.lineParams[i][j], "hardmin")) {
                tempParam.hardMin = newLineshapeData.lineParams[i][j].hardmin;
              } else if (
                Object.prototype.hasOwnProperty.call(tempParam, "hardMin")
              ) {
                delete tempParam.hardMin;
              }
              if (!tempParam.fixed) {
                if (hasProperty(newLineshapeData.lineParams[i][j], "fixed")) {
                  tempParam.customFixed =
                    newLineshapeData.lineParams[i][j].fixed;
                }
                if (
                  hasProperty(newLineshapeData.lineParams[i][j], "customFixed")
                ) {
                  tempParam.customFixed =
                    newLineshapeData.lineParams[i][j].customFixed;
                }
              }
              params.push(tempParam);
              row[tempParam.name] = tempParam.value;
            }
          }
          newLineshapeData.lineTableRows.push(row);
          newLineshapeData.lineParams[i] = params;
        }
      }
      if (lineshapeIndex !== -1) {
        modelTemplateCopy.lineshapeData[lineshapeIndex] =
          deepCopy(newLineshapeData);
      } else {
        modelTemplateCopy.lineshapeData.push(deepCopy(newLineshapeData));
      }
    }
    if (lineshapesToQuery.length > 0) {
      sendJsonMessage(
        {
          User: currentUser.id,
          Model: { GetShapeSpecs: lineshapesToQuery },
        },
        { type: "get-shape-specs", requestedModelID: [] }
      );
    }
  }
  return modelTemplateCopy;
}

export function convertModelFormat(model) {
  // Function to convert the model from files to keep backwards compatibility with old models
  let modeltypeParam = model.parameters.global.find(
    (param) => param.speqqle_id === -1
  );
  if (
    !modeltypeParam ||
    model.parameters.global.length === 1 ||
    (modeltypeParam.value < 0 && modeltypeParam.fixed)
  ) {
    return model;
  }
  const modelCopy = deepCopy(model);
  let largerstSpeqqleID = model.parameters.global.reduce(
    (max, param) => Math.max(max, param.speqqle_id),
    0
  );
  let numberOfLineshapes = Math.floor(largerstSpeqqleID / 3);
  let lineshapesParameters = [];
  for (let i = 0; i <= numberOfLineshapes; i++) {
    let lineshapeParameters = [];
    for (let j = 0; j < 3; j++) {
      let param = deepCopy(
        model.parameters.global.find((param) => param.speqqle_id === i * 3 + j)
      );
      param.speqqle_id = j;
      if (param) {
        lineshapeParameters.push(param);
      } else {
        modelCopy.parameters.global = [
          modelCopy.parameters.global.find((param) => param.speqqle_id === -1),
        ];
        return modelCopy;
      }
    }

    lineshapesParameters.push(lineshapeParameters);
  }
  modelCopy.parameters.global = [
    modelCopy.parameters.global.find((param) => param.speqqle_id === -1),
  ];
  modelCopy.parameters.lineshapes = [
    { lineshape_id: 0, shapes: lineshapesParameters },
  ];
  return modelCopy;
}

export function collectClashingGroupsFromNonRecParams(
  model,
  valueGroups,
  clashingGroups,
  groupsUpdate
) {
  let localGroupsUpdate = groupsUpdate;

  for (let i = 0; i < model.modelParams.length; i++) {
    const param = model.modelParams[i];

    if (param.recuring === 0 && hasProperty(param, "group")) {
      const matchingGroup = valueGroups.find(
        (group) => group.groupNumber === param.group
      );

      // Skip inactive groups (null value) in the existing valueGroups
      if (matchingGroup.value === null) {
        localGroupsUpdate = localGroupsUpdate.map((group) => {
          if (group.groupNumber === param.group) {
            return {
              ...group,
              value: param.value,
              hardMax:
                param.hardMax !== undefined ? param.hardMax : group.hardMax,
              hardMin:
                param.hardMin !== undefined ? param.hardMin : group.hardMin,
              fixed:
                param.customFixed !== undefined
                  ? param.customFixed
                  : group.fixed,
              memberCount: group.memberCount + 1,
            };
          } else {
            return group;
          }
        });
      } else {
        // Check for conflicts in any of the properties: value, hardMax, hardMin, or fixed
        const valueConflict = matchingGroup.value !== param.value;
        const hardMaxConflict = !(
          (matchingGroup.hardMax === null && !hasProperty(param, "hardMax")) ||
          (hasProperty(param, "hardMax") &&
            matchingGroup.hardMax === param.hardMax)
        );
        const hardMinConflict = !(
          (matchingGroup.hardMin === null && !hasProperty(param, "hardMin")) ||
          (hasProperty(param, "hardMin") &&
            matchingGroup.hardMin === param.hardMin)
        );
        const fixedConflict = !(
          (matchingGroup.fixed === null && !param.customFixed) ||
          matchingGroup.fixed === param.customFixed
        );

        if (
          valueConflict ||
          hardMaxConflict ||
          hardMinConflict ||
          fixedConflict
        ) {
          if (hasProperty(clashingGroups, param.group)) {
            clashingGroups = {
              ...clashingGroups,
              [param.group]: {
                ...clashingGroups[param.group],
                currentValue: matchingGroup.value,
                incomingValue: param.value,
                currentHardMax: matchingGroup.hardMax,
                incomingHardMax: param.hardMax,
                currentHardMin: matchingGroup.hardMin,
                incomingHardMin: param.hardMin,
                currentFixed: matchingGroup.fixed,
                incomingFixed: param.customFixed,
                memberCount: clashingGroups[param.group].memberCount + 1,
                // Track which properties are conflicting
                conflicts: {
                  value: valueConflict,
                  hardMax: hardMaxConflict,
                  hardMin: hardMinConflict,
                  fixed: fixedConflict,
                },
              },
            };
          } else {
            clashingGroups = {
              ...clashingGroups,
              [param.group]: {
                currentValue: matchingGroup.value,
                incomingValue: param.value,
                currentHardMax: matchingGroup.hardMax,
                incomingHardMax: param.hardMax,
                currentHardMin: matchingGroup.hardMin,
                incomingHardMin: param.hardMin,
                currentFixed: matchingGroup.fixed,
                incomingFixed: param.customFixed,
                memberCount: 1,
                // Track which properties are conflicting
                conflicts: {
                  value: valueConflict,
                  hardMax: hardMaxConflict,
                  hardMin: hardMinConflict,
                  fixed: fixedConflict,
                },
              },
            };
          }
        } else {
          localGroupsUpdate = localGroupsUpdate.map((group) => {
            if (group.groupNumber === param.group) {
              return {
                ...group,
                memberCount: group.memberCount + 1,
              };
            } else {
              return group;
            }
          });
        }
      }
    }
  }

  return {
    clashingGroups,
    groupsUpdate: localGroupsUpdate,
  };
}

export function collectClashingGroupsFromRecParams(
  model,
  valueGroups,
  clashingGroups,
  groupsUpdate
) {
  let localClashingGroups = clashingGroups;
  let localGroupsUpdate = groupsUpdate;

  if (hasProperty(model, "recParams")) {
    for (let i = 0; i < model.recParams.length; i++) {
      const paramRow = model.recParams[i];

      for (let j = 0; j < paramRow.length; j++) {
        const param = paramRow[j];
        if (hasProperty(param, "group")) {
          const matchingGroup = valueGroups.find(
            (group) => group.groupNumber === param.group
          );

          // Skip inactive groups (null value) in the existing valueGroups
          if (matchingGroup.value === null) {
            localGroupsUpdate = localGroupsUpdate.map((group) => {
              if (group.groupNumber === param.group) {
                return {
                  ...group,
                  value: param.value,
                  hardMax:
                    param.hardMax !== undefined ? param.hardMax : group.hardMax,
                  hardMin:
                    param.hardMin !== undefined ? param.hardMin : group.hardMin,
                  fixed:
                    param.customFixed !== undefined
                      ? param.customFixed
                      : group.fixed,
                  memberCount: group.memberCount + 1,
                };
              } else {
                return group;
              }
            });
          } else {
            // Check for conflicts in any of the properties: value, hardMax, hardMin, or fixed
            const valueConflict = matchingGroup.value !== param.value;
            const hardMaxConflict = !(
              (matchingGroup.hardMax === null &&
                !hasProperty(param, "hardMax")) ||
              (hasProperty(param, "hardMax") &&
                matchingGroup.hardMax === param.hardMax)
            );
            const hardMinConflict = !(
              (matchingGroup.hardMin === null &&
                !hasProperty(param, "hardMin")) ||
              (hasProperty(param, "hardMin") &&
                matchingGroup.hardMin === param.hardMin)
            );
            const fixedConflict = !(
              (matchingGroup.fixed === null && !param.customFixed) ||
              matchingGroup.fixed === param.customFixed
            );

            if (
              valueConflict ||
              hardMaxConflict ||
              hardMinConflict ||
              fixedConflict
            ) {
              if (hasProperty(localClashingGroups, param.group)) {
                localClashingGroups = {
                  ...localClashingGroups,
                  [param.group]: {
                    ...localClashingGroups[param.group],
                    currentValue: matchingGroup.value,
                    incomingValue: param.value,
                    currentHardMax: matchingGroup.hardMax,
                    incomingHardMax: param.hardMax,
                    currentHardMin: matchingGroup.hardMin,
                    incomingHardMin: param.hardMin,
                    currentFixed: matchingGroup.fixed,
                    incomingFixed: param.customFixed,
                    memberCount:
                      localClashingGroups[param.group].memberCount + 1,
                    // Track which properties are conflicting
                    conflicts: {
                      value:
                        valueConflict ||
                        localClashingGroups[param.group].conflicts?.value ||
                        false,
                      hardMax:
                        hardMaxConflict ||
                        localClashingGroups[param.group].conflicts?.hardMax ||
                        false,
                      hardMin:
                        hardMinConflict ||
                        localClashingGroups[param.group].conflicts?.hardMin ||
                        false,
                      fixed:
                        fixedConflict ||
                        localClashingGroups[param.group].conflicts?.fixed ||
                        false,
                    },
                  },
                };
              } else {
                localClashingGroups = {
                  ...localClashingGroups,
                  [param.group]: {
                    currentValue: matchingGroup.value,
                    incomingValue: param.value,
                    currentHardMax: matchingGroup.hardMax,
                    incomingHardMax: param.hardMax,
                    currentHardMin: matchingGroup.hardMin,
                    incomingHardMin: param.hardMin,
                    currentFixed: matchingGroup.fixed,
                    incomingFixed: param.customFixed,
                    memberCount: 1,
                    // Track which properties are conflicting
                    conflicts: {
                      value: valueConflict,
                      hardMax: hardMaxConflict,
                      hardMin: hardMinConflict,
                      fixed: fixedConflict,
                    },
                  },
                };
              }
            } else {
              localGroupsUpdate = localGroupsUpdate.map((group) => {
                if (group.groupNumber === param.group) {
                  return {
                    ...group,
                    memberCount: group.memberCount + 1,
                  };
                } else {
                  return group;
                }
              });
            }
          }
        }
      }
    }
  }

  return {
    clashingGroups: localClashingGroups,
    groupsUpdate: localGroupsUpdate,
  };
}

export function collectClashingGroupsLineshapes(
  model,
  valueGroups,
  clashingGroups,
  groupsUpdate
) {
  let localClashingGroups = clashingGroups;
  let localGroupsUpdate = groupsUpdate;
  if (!hasProperty(model, "lineshapeData")) {
    return {
      clashingGroups: localClashingGroups,
      groupsUpdate: localGroupsUpdate,
    };
  }
  for (let i = 0; i < model.lineshapeData.length; i++) {
    for (let j = 0; j < model.lineshapeData[i].lineParams.length; j++) {
      const paramRow = model.lineshapeData[i].lineParams[j];

      for (let k = 0; k < paramRow.length; k++) {
        const param = paramRow[k];
        if (hasProperty(param, "group")) {
          const matchingGroup = valueGroups.find(
            (group) => group.groupNumber === param.group
          );

          // Skip inactive groups (null value) in the existing valueGroups
          if (matchingGroup.value === null) {
            localGroupsUpdate = localGroupsUpdate.map((group) => {
              if (group.groupNumber === param.group) {
                return {
                  ...group,
                  value: param.value,
                  hardMax:
                    param.hardMax !== undefined ? param.hardMax : group.hardMax,
                  hardMin:
                    param.hardMin !== undefined ? param.hardMin : group.hardMin,
                  fixed:
                    param.customFixed !== undefined
                      ? param.customFixed
                      : group.fixed,
                  memberCount: group.memberCount + 1,
                };
              } else {
                return group;
              }
            });
          } else {
            // Check for conflicts in any of the properties: value, hardMax, hardMin, or fixed
            const valueConflict = matchingGroup.value !== param.value;
            const hardMaxConflict = !(
              (matchingGroup.hardMax === null &&
                !hasProperty(param, "hardMax")) ||
              (hasProperty(param, "hardMax") &&
                matchingGroup.hardMax === param.hardMax)
            );
            const hardMinConflict = !(
              (matchingGroup.hardMin === null &&
                !hasProperty(param, "hardMin")) ||
              (hasProperty(param, "hardMin") &&
                matchingGroup.hardMin === param.hardMin)
            );
            const fixedConflict = !(
              (matchingGroup.fixed === null && !param.customFixed) ||
              matchingGroup.fixed === param.customFixed
            );

            if (
              valueConflict ||
              hardMaxConflict ||
              hardMinConflict ||
              fixedConflict
            ) {
              if (hasProperty(localClashingGroups, param.group)) {
                localClashingGroups = {
                  ...localClashingGroups,
                  [param.group]: {
                    ...localClashingGroups[param.group],
                    currentValue: matchingGroup.value,
                    incomingValue: param.value,
                    currentHardMax: matchingGroup.hardMax,
                    incomingHardMax: param.hardMax,
                    currentHardMin: matchingGroup.hardMin,
                    incomingHardMin: param.hardMin,
                    currentFixed: matchingGroup.fixed,
                    incomingFixed: param.customFixed,
                    memberCount:
                      localClashingGroups[param.group].memberCount + 1,
                    // Track which properties are conflicting
                    conflicts: {
                      value:
                        valueConflict ||
                        localClashingGroups[param.group].conflicts?.value ||
                        false,
                      hardMax:
                        hardMaxConflict ||
                        localClashingGroups[param.group].conflicts?.hardMax ||
                        false,
                      hardMin:
                        hardMinConflict ||
                        localClashingGroups[param.group].conflicts?.hardMin ||
                        false,
                      fixed:
                        fixedConflict ||
                        localClashingGroups[param.group].conflicts?.fixed ||
                        false,
                    },
                  },
                };
              } else {
                localClashingGroups = {
                  ...localClashingGroups,
                  [param.group]: {
                    currentValue: matchingGroup.value,
                    incomingValue: param.value,
                    currentHardMax: matchingGroup.hardMax,
                    incomingHardMax: param.hardMax,
                    currentHardMin: matchingGroup.hardMin,
                    incomingHardMin: param.hardMin,
                    currentFixed: matchingGroup.fixed,
                    incomingFixed: param.customFixed,
                    memberCount: 1,
                    // Track which properties are conflicting
                    conflicts: {
                      value: valueConflict,
                      hardMax: hardMaxConflict,
                      hardMin: hardMinConflict,
                      fixed: fixedConflict,
                    },
                  },
                };
              }
            } else {
              localGroupsUpdate = localGroupsUpdate.map((group) => {
                if (group.groupNumber === param.group) {
                  return {
                    ...group,
                    memberCount: group.memberCount + 1,
                  };
                } else {
                  return group;
                }
              });
            }
          }
        }
      }
    }
  }
  return {
    clashingGroups: localClashingGroups,
    groupsUpdate: localGroupsUpdate,
  };
}

export function allContainedGroups(model) {
  const containedGroups = {};

  // Process this model's non-recurring parameters
  for (let i = 0; i < model.modelParams.length; i++) {
    const param = model.modelParams[i];

    if (param.recuring === 0 && hasProperty(param, "group")) {
      if (hasProperty(containedGroups, param.group)) {
        containedGroups[param.group] = {
          value: param.value,
          memberCount: containedGroups[param.group].memberCount + 1,
        };
      } else {
        containedGroups[param.group] = {
          value: param.value,
          memberCount: 1,
        };
      }
    }
  }

  // Process recurring parameters
  if (hasProperty(model, "recParams")) {
    for (let i = 0; i < model.recParams.length; i++) {
      const paramRow = model.recParams[i];

      for (let j = 0; j < paramRow.length; j++) {
        const param = paramRow[j];
        if (hasProperty(param, "group")) {
          if (hasProperty(containedGroups, param.group)) {
            containedGroups[param.group] = {
              value: param.value,
              memberCount: containedGroups[param.group].memberCount + 1,
            };
          } else {
            containedGroups[param.group] = {
              value: param.value,
              memberCount: 1,
            };
          }
        }
      }
    }
  }

  // Process lineshape parameters
  if (hasProperty(model, "lineshapeData")) {
    for (let i = 0; i < model.lineshapeData.length; i++) {
      for (let j = 0; j < model.lineshapeData[i].lineParams.length; j++) {
        const paramRow = model.lineshapeData[i].lineParams[j];
        for (let k = 0; k < paramRow.length; k++) {
          const param = paramRow[k];
          if (hasProperty(param, "group")) {
            if (hasProperty(containedGroups, param.group)) {
              containedGroups[param.group] = {
                value: param.value,
                memberCount: containedGroups[param.group].memberCount + 1,
              };
            } else {
              containedGroups[param.group] = {
                value: param.value,
                memberCount: 1,
              };
            }
          }
        }
      }
    }
  }

  // Recursively process submodels
  if (hasProperty(model, "subModels") && model.subModels.length > 0) {
    for (let i = 0; i < model.subModels.length; i++) {
      const subModel = model.subModels[i];
      const subModelGroups = allContainedGroups(subModel);

      // Merge the submodel's groups with the current model's groups
      for (const groupNumber in subModelGroups) {
        if (hasProperty(containedGroups, groupNumber)) {
          containedGroups[groupNumber] = {
            value: subModelGroups[groupNumber].value,
            memberCount:
              containedGroups[groupNumber].memberCount +
              subModelGroups[groupNumber].memberCount,
          };
        } else {
          containedGroups[groupNumber] = subModelGroups[groupNumber];
        }
      }
    }
  }

  return containedGroups;
}

/**
 * Updates valueGroups specifically for linked models by calculating the difference
 * between the original model and replacement model group memberships
 * @function
 * @param {Array} currentValueGroups - Current valueGroups state
 * @param {Object} modelToBeReplaced - The original model being replaced
 * @param {Object} replacementModel - The model that will replace the original model
 * @returns {Array} Updated valueGroups with correct member counts
 */
export function updateGroupsAfterLinking(
  currentValueGroups,
  modelToBeReplaced,
  replacementModel
) {
  try {
    // Check if either model has groups - if not, we can return early
    const originalModelGroups = allContainedGroups(modelToBeReplaced);
    const replacementModelGroups = allContainedGroups(replacementModel);

    // If neither model has any groups, no need to update valueGroups
    if (
      Object.keys(originalModelGroups).length === 0 &&
      Object.keys(replacementModelGroups).length === 0
    ) {
      return currentValueGroups;
    }

    // Create a deep copy of the valueGroups to modify
    const valueGroupsCopy = deepCopy(currentValueGroups);

    // Process removals from original model first
    for (const groupNumber in originalModelGroups) {
      const groupIndex = parseInt(groupNumber) - 1;
      if (
        groupIndex >= 0 &&
        groupIndex < valueGroupsCopy.length &&
        valueGroupsCopy[groupIndex] !== null
      ) {
        // Subtract the member count of this group in the original model
        const newCount =
          valueGroupsCopy[groupIndex].memberCount -
          originalModelGroups[groupNumber].memberCount;

        valueGroupsCopy[groupIndex].memberCount = Math.max(0, newCount);
        valueGroupsCopy[groupIndex].numberOfEntries =
          valueGroupsCopy[groupIndex].memberCount;

        // Reset group values if no members left
        if (valueGroupsCopy[groupIndex].memberCount === 0) {
          valueGroupsCopy[groupIndex].value = null;
          valueGroupsCopy[groupIndex].hardMax = null;
          valueGroupsCopy[groupIndex].hardMin = null;
          valueGroupsCopy[groupIndex].fixed = null;
        }
      }
    }

    // Then add counts from the replacement model
    for (const groupNumber in replacementModelGroups) {
      const groupIndex = parseInt(groupNumber) - 1;
      if (
        groupIndex >= 0 &&
        groupIndex < valueGroupsCopy.length &&
        valueGroupsCopy[groupIndex] !== null
      ) {
        // Add the member count of this group in the replacement model
        valueGroupsCopy[groupIndex].memberCount +=
          replacementModelGroups[groupNumber].memberCount;
        valueGroupsCopy[groupIndex].numberOfEntries =
          valueGroupsCopy[groupIndex].memberCount;

        // If this group was empty before and now has members, initialize with the model's value
        if (
          valueGroupsCopy[groupIndex].value === null &&
          replacementModelGroups[groupNumber].memberCount > 0
        ) {
          valueGroupsCopy[groupIndex].value =
            replacementModelGroups[groupNumber].value;
        }
      }
    }

    return valueGroupsCopy;
  } catch (error) {
    console.error("Error updating groups after linking: ", error);
    return currentValueGroups; // Return original if there's an error
  }
}

export function updateRecParamsAndRows(
  modelsToUpdate,
  modelToReplaceID,
  newModel,
  indexChain
) {
  let modelsCopy = deepCopy(modelsToUpdate);

  const modelChain = getUpdatedUniqueIds([modelToReplaceID], modelsToUpdate);

  const indexOfParentModel = modelChain.indexOf(modelToReplaceID) - 1;

  if (indexOfParentModel < 0) {
    return null;
  }

  let parentModel = getModelById(modelChain[indexOfParentModel], modelsCopy);

  parentModel = updateParamsAndRowsOfModel(
    parentModel,
    modelToReplaceID,
    newModel,
    indexChain
  );

  modelsCopy = replaceModelById(modelsCopy, parentModel, parentModel.FE_ID);

  return modelsCopy;
}

function updateParamsAndRowsOfModel(
  parentModel,
  modelToReplaceID,
  newModel,
  indexChain
) {
  const indexChainInt = indexChain.split(";").map((index) => parseInt(index));

  // Code below calculates which parameter row to use based on how many sub models are per line,
  // based on subModelTypes property in parent model
  const subModelsPerLine = parentModel.subModelTypes.length;
  const indexOfRow = Math.floor(
    indexChainInt[indexChainInt.length - 1] / subModelsPerLine
  );

  const parentModelCopy = deepCopy(parentModel);

  // This complicated index finder makes sure that we select the right sub model even if there are other
  // parameters in between them.
  const indexesOfModelsInParams = parentModelCopy.recParams[indexOfRow]
    .map((param, index) => (hasProperty(param, "FE_ID") ? index : null))
    .filter((entry) => entry !== null);
  const indexOfParam =
    indexesOfModelsInParams[
      indexChainInt[indexChainInt.length - 1] % subModelsPerLine
    ];

  if (hasProperty(parentModelCopy, "recParams")) {
    const param = parentModelCopy.recParams[indexOfRow][indexOfParam];
    if (hasProperty(param, "FE_ID") && param.FE_ID === modelToReplaceID) {
      // This is faulty when user unlinks 2 models from the same line
      parentModelCopy.recParams[indexOfRow][indexOfParam].FE_ID =
        newModel.FE_ID;
      parentModelCopy.recTableRows[indexOfRow][param.name] =
        newModel.displayName;
    }
  }

  return parentModelCopy;
}

export function getParentModelFromIndexChain(modelData, indexChain) {
  const listOfIndexesInOrder = indexChain
    .split(";")
    .map((index) => parseInt(index));
  // We only need parent, not current model, so we remove its index
  listOfIndexesInOrder.pop();

  if (listOfIndexesInOrder.length === 1) {
    return modelData[listOfIndexesInOrder[0]];
  }
  if (listOfIndexesInOrder.length === 0) {
    return null;
  }

  const checkAndReturnModel = (modelListToCheck) => {
    const possibleParentIndex = listOfIndexesInOrder.shift();

    if (listOfIndexesInOrder.length === 0) {
      //We found the parent

      return modelListToCheck[possibleParentIndex];
    }

    return checkAndReturnModel(modelListToCheck[possibleParentIndex].subModels);
  };

  const granParentIndex = listOfIndexesInOrder.shift();

  return checkAndReturnModel(modelData[granParentIndex].subModels);
}
